import { render } from "./NumberCard.vue?vue&type=template&id=51ad07ac&scoped=true"
import script from "./NumberCard.vue?vue&type=script&lang=js"
export * from "./NumberCard.vue?vue&type=script&lang=js"

import "./NumberCard.vue?vue&type=style&index=0&id=51ad07ac&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ad07ac"]])

export default __exports__